<template>
<div class="apply">
  <div>
    <van-form @submit="onSubmit" ref="applyForm">
      <van-field
        left-icon="diamond-o"
        readonly
        v-model="formData.itemTitle"
        name="itemTitle"
        label="商品名称"
      />

      <van-field
        left-icon="manager-o"
        v-model="formData.workNumber"
        name="workNumber"
        label="工号"
        placeholder="请输入工号"
      />
      <van-field
        left-icon="logistics"
        v-model="formData.personalName"
        name="personalName"
        label="收件人"
        placeholder="请输入收件人姓名"
        rule="personalName"
        :rules="[{ required: true, message: '请输入收件人姓名' }]"
      />

      <van-field
        left-icon="phone-o"
        v-model="formData.phoneNumber"
        name="phoneNumber"
        label="手机号"
        type="tel"
        placeholder="请输入收件人手机号"
       :rules="[{ required: true, pattern,message: '请输入正确手机号' }]"
      />

      <van-field name="itemCount" label="购买数量" left-icon="goods-collect-o">
        <template #input>
          <van-stepper v-model="formData.itemCount" />
        </template>
      </van-field>

      <van-field
        left-icon="chat-o"
        v-model="formData.remark"
        rows="2"
        autosize
        label="备注"
        name="remark"
        type="textarea"
        maxlength="50"
        placeholder="如果需要快递，请输入收件人地址"
        show-word-limit
      />

      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">
          提交
        </van-button>
      </div>
    </van-form>
  </div>
</div>
</template>
<script>
import { Form, Field, Stepper, Dialog } from 'vant'
import { commitOrder } from 'api'
export default {
  name: 'Apply',
  components: {
    [Form.name]: Form,
    [Field.name]: Field,
    [Stepper.name]: Stepper,
    [Dialog.name]: Dialog
  },
  data () {
    return {
      pattern: /^[1][3,4,5,7,8][0-9]{9}$/,
      formData: {
        itemId: null,
        itemTitle: '',
        workNumber: '',
        personalName: '',
        phoneNumber: '',
        itemCount: 1,
        remark: ''
      }
    }
  },
  mounted () {
    this.getDetailGoodsList()
  },
  methods: {
    getDetailGoodsList () {
      const goodsDetailList = JSON.parse(localStorage.getItem('goodsDetailList'))
      this.formData.itemId = goodsDetailList.id
      this.formData.itemTitle = goodsDetailList.itemTitle
    },
    onSubmit (par) {
      const query = new URLSearchParams()
      query.append('itemId', this.formData.itemId)
      query.append('itemTitle', par.itemTitle)
      query.append('workNumber', par.workNumber)
      query.append('personalName', par.personalName)
      query.append('phoneNumber', par.phoneNumber)
      query.append('itemCount', par.itemCount)
      query.append('remark', par.remark)

      commitOrder({ query }).then((data) => {
        if (data.data.code === 0) {
          Dialog.alert({
            title: '申请成功',
            message: '稍后会有工作人员和您取得联系，\n 申请单号：' + data.data.data
          }).then(() => {
            this.$router.push({
              path: '/'
            })
          })
        } else {
          Dialog.alert({
            title: '申请失败',
            message: data.data.msg
          }).then(() => {
            console.dir(data)
          })
        }
      })
    }
  }
}
</script>
<style scoped>
</style>
